module.exports = " <p-cascader @on-change=onChange :value.sync=val :change-on-select=changeOnSelect :data=data :trigger=trigger :size=size :clearable=clearable :disabled=disabled :render-format=renderFormat :load-data=loadSubData :placeholder=placeholder></p-cascader> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/xman/category/category.vue
// module id = 302
// module chunks = 0